/**
 * API validation responses that are already surfaced in the UI via error.response.data.Message.
 */
export function isExpectedBusinessError(err) {
  try {
    if (!err?.isAxiosError) {
      return false;
    }

    const message = err.response?.data?.Message;

    return err.response?.status === 400 && typeof message === 'string' && message.length > 0;
  } catch {
    return false;
  }
}

function formatExpectedBusinessErrorLog(err) {
  const url = err.config?.url ?? 'unknown';
  const message = err.response?.data?.Message;

  return `[react-query] Expected business validation (400): ${url} - ${message}`;
}

export const reactQueryLogger = {
  log(...args) {
    console.log(...args);
  },
  warn(...args) {
    console.warn(...args);
  },
  error(err) {
    try {
      if (isExpectedBusinessError(err)) {
        console.warn(formatExpectedBusinessErrorLog(err));

        return;
      }
    } catch {
      // fall through to default logging
    }

    console.error(err);
  },
};
